import { createFileRoute, redirect } from '@tanstack/react-router';

import { scratchpadSearchSchema } from '@apps/web/features/admin_agent_scratchpad/model/search_params';

export const Route = createFileRoute('/_app/admin/agent/scratchpad/')({
    beforeLoad: ({ location }) => {
        throw redirect({
            to: '/admin/agent/notes',
            search: scratchpadSearchSchema.parse(location.search),
            replace: true,
        });
    },
});
